<div style="background: white; border-radius: 12px; padding: 16px; margin-bottom: 20px; border: 2px solid #e0e0e0;">
  <div style="text-align: center;">
    <span style="font-size: 13px; color: #6b7280; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">Tipo de cambio</span>
    <div style="margin-top: 8px;">
      <span style="font-size: 18px; font-weight: 700; color: #1C593D;">Comprar VES</span>
    </div>
    <div style="margin-top: 12px; font-size: 22px; font-weight: 800; color: #111827;">
      1 CLP = {{ ves_buy_rate | number:'1.0-5' }} VES
    </div>
    <img *ngIf="!hasLoaded" src="assets/loader.svg" height="40" width="40" style="margin: 12px auto 0; display: block;" alt="Cargando">
  </div>
</div>
